// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","389":"633ef6ce","453":"54292a4b","455":"60fa4b3a","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};